import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import {
  getFirestore,
  collection,
  getDocs,
  doc,
  getDoc,
} from "firebase/firestore";
import { app } from "../firebase";
;

/* ======================= ESTILOS (só layout, sem mudar lógica) ======================= */
const Main = styled.main`
  flex: 1;
  padding: 2rem 4rem;
  background-color: #f3f7ff;

  display: flex;
  flex-direction: column;
  gap: 1.25rem;
  margin: 0 auto;

  @media (max-width: 1024px) { padding: 2rem; }
  @media (max-width: 680px)  { padding: 1rem; }
`;

const Header = styled.header`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  flex-wrap: wrap;
`;

const Title = styled.h1`
  font-size: 1.5rem;
  font-weight: 700;
  color: #1F1A40;
  margin: 0;

  @media (max-width: 680px) { font-size: 1.5rem; }
`;

const Badge = styled.span`
  background: #e6efff;
  color: #1a3d7c;
  padding: 8px 14px;
  border-radius: 999px;
  font-weight: 700;
  font-size: 0.95rem;
  white-space: nowrap;
`;

const StatGrid = styled.section`
  display: grid;
  gap: 1rem;
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
`;

const Card = styled.div`
  background: #fff;
  border-radius: 1rem;
  padding: 1.25rem;
  box-shadow: 0 8px 24px rgba(0,0,0,.06);
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
  min-height: 132px;
`;

const CardTitle = styled.h2`
  font-size: 1.05rem;
  font-weight: 800;
  color: #1F1A40;
  margin: 0;
`;

const Value = styled.div`
  font-size: 2.1rem;
  font-weight: 900;
  color: #1F1A40;

  @media (max-width: 1024px) { font-size: 1.9rem; }
  @media (max-width: 680px)  { font-size: 1.7rem; }
`;

const Subtle = styled.div`
  margin-top: auto;
  font-size: 0.85rem;
  color: #6b7280;
`;

const TwoCol = styled.div`
  display: grid;
  gap: 1rem;
  grid-template-columns: repeat(2, minmax(0, 1fr));

  @media (max-width: 760px) {
    grid-template-columns: 1fr;
  }
`;

/* ======================= COMPONENTE ======================= */
export default function ComissaoPage() {
  const [comissaoHoje, setComissaoHoje] = useState(0);
  const [comissaoSemana, setComissaoSemana] = useState(0);
  const [comissaoMes, setComissaoMes] = useState(0);
  const [comissao30dias, setComissao30dias] = useState(0);
  const [percentualComissao, setPercentualComissao] = useState(0);
  const [barbeariaId, setBarbeariaId] = useState(null);

  const auth = getAuth(app);
  const db = getFirestore(app);

  useEffect(() => {
    const resetTime = (date) => {
      const d = new Date(date);
      d.setHours(0, 0, 0, 0);
      return d;
    };

    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (!user) return;
      const uid = user.uid;

      const barbeariasSnap = await getDocs(collection(db, "barbearia"));
      for (const barbearia of barbeariasSnap.docs) {
        const barbeiroRef = doc(db, `barbearia/${barbearia.id}/barbeiros/${uid}`);
        const barbeiroSnap = await getDoc(barbeiroRef);

        if (barbeiroSnap.exists()) {
          const { comissao = 0 } = barbeiroSnap.data();
          setPercentualComissao(comissao);
          setBarbeariaId(barbearia.id);

          // Serviços
          const servicosSnap = await getDocs(collection(db, `barbearia/${barbearia.id}/servico`));
          const mapaServicos = {};
          servicosSnap.forEach(docu => {
            mapaServicos[docu.id] = docu.data().valor || 0;
          });

          // Agendamentos
          const agendamentosSnap = await getDocs(collection(db, `barbearia/${barbearia.id}/agendamentos`));

          const hoje = resetTime(new Date());
          const seteDiasAtras = resetTime(new Date()); seteDiasAtras.setDate(hoje.getDate() - 6);
          const inicioMes = resetTime(new Date(hoje.getFullYear(), hoje.getMonth(), 1));
          const trintaDiasAtras = resetTime(new Date()); trintaDiasAtras.setDate(hoje.getDate() - 30);

          let totalHoje = 0;
          let totalSemana = 0;
          let totalMes = 0;
          let total30dias = 0;

          agendamentosSnap.forEach((docu) => {
            const ag = docu.data();
            if (ag.status !== "confirmado" || ag.barbeiroId !== uid) return;

            const [ano, mes, dia] = ag.data.split("-");
            const dataAgendamento = resetTime(new Date(Number(ano), Number(mes) - 1, Number(dia)));
            const valorServico = mapaServicos[ag.servicoId] || 0;
            const valorComissao = (valorServico * comissao) / 100;

            if (isSameDay(dataAgendamento, hoje)) totalHoje += valorComissao;
            if (dataAgendamento >= seteDiasAtras && dataAgendamento <= hoje) totalSemana += valorComissao;
            if (dataAgendamento >= inicioMes && dataAgendamento <= hoje) totalMes += valorComissao;
            if (dataAgendamento >= trintaDiasAtras && dataAgendamento <= hoje) total30dias += valorComissao;
          });

          setComissaoHoje(totalHoje);
          setComissaoSemana(totalSemana);
          setComissaoMes(totalMes);
          setComissao30dias(total30dias);
          break;
        }
      }
    });

    return () => unsubscribe();
  }, []);

  function resetTime(date) {
    const d = new Date(date);
    d.setHours(0, 0, 0, 0);
    return d;
  }

  function isSameDay(date1, date2) {
    return (
      date1.getFullYear() === date2.getFullYear() &&
      date1.getMonth() === date2.getMonth() &&
      date1.getDate() === date2.getDate()
    );
  }

  function formatarValor(valor) {
    return valor.toLocaleString("pt-BR", { style: "currency", currency: "BRL" });
  }

  return (
    <>
      <Main>
        <Header>
          <Badge>Comissão do barbeiro: <strong>{percentualComissao}%</strong></Badge>
        </Header>

        {/* Cards grandes em grid (responsivo) */}
        <StatGrid>
          <Card>
            <CardTitle>Comissão Prevista de Hoje</CardTitle>
            <Value>{formatarValor(comissaoHoje)}</Value>
            <Subtle>Atualizado com base nos atendimentos confirmados de hoje.</Subtle>
          </Card>

          <Card>
            <CardTitle>Comissão Últimos 7 Dias</CardTitle>
            <Value>{formatarValor(comissaoSemana)}</Value>
            <Subtle>Semana corrente (inclui hoje).</Subtle>
          </Card>

          <Card>
            <CardTitle>Comissão Últimos 30 Dias</CardTitle>
            <Value>{formatarValor(comissao30dias)}</Value>
            <Subtle>Móvel: últimos 30 dias a partir de hoje.</Subtle>
          </Card>

          <Card>
            <CardTitle>Comissão do Mês</CardTitle>
            <Value>{formatarValor(comissaoMes)}</Value>
            <Subtle>Desde o 1º dia do mês até hoje.</Subtle>
          </Card>
        </StatGrid>

        {/* Se quiser manter duas colunas “irmãs” como antes, também deixei um bloco pronto:
        <TwoCol>
          <Card>...</Card>
          <Card>...</Card>
        </TwoCol>
        */}
      </Main>
    </>
  );
}
